export enum AccountTeamUserApiErrorTypes {
  InviteUserError,
  ConflictUserError,
  LoadAccountTeamUsersError,
  UpdateOrganizationRolesError,
  RemoveUserError,
}

export class AccountTeamUserApiError {
  constructor(public type: AccountTeamUserApiErrorTypes, public error: Error) {}
}
